export var MetricType;
(function (MetricType) {
    MetricType["BloodOxygen"] = "spo2";
    MetricType["BloodPressure"] = "bp";
    MetricType["BloodSugar"] = "glucose";
    MetricType["BodyHeight"] = "height";
    MetricType["BodyMassIndex"] = "bmi";
    MetricType["BodyTemperature"] = "temperature";
    MetricType["BodyWeight"] = "weight";
    MetricType["DailySteps"] = "steps";
    MetricType["FoetalHeartRate"] = "foetal_hr";
    MetricType["FoetalHeartRateVariability"] = "foetal_hrv";
    MetricType["HeartRateVariability"] = "hrv";
    MetricType["RestingHeartRate"] = "resting_hr";
    MetricType["SleepTime"] = "sleep";
    MetricType["UterineActivity"] = "uterine";
    MetricType["Arrhythmia"] = "arrhythmia";
    MetricType["AbdominalCircumference"] = "abd_circum";
})(MetricType || (MetricType = {}));
export var MealSituation;
(function (MealSituation) {
    MealSituation["Fasting"] = "fasting";
    MealSituation["BeforeMeal"] = "before_meal";
    MealSituation["AfterMeal"] = "after_meal";
    MealSituation["Random"] = "random";
})(MealSituation || (MealSituation = {}));
export const metricTypesManualAllowed = [
    MetricType.BodyWeight,
    MetricType.BodyHeight,
    MetricType.BodyTemperature,
    MetricType.BloodPressure,
    MetricType.BloodSugar,
    MetricType.BloodOxygen,
    MetricType.AbdominalCircumference,
];
export const isManualAllowed = (metricType) => metricTypesManualAllowed.includes(metricType); // This is ugly TODO: Try without casting
export const isDaily = (metricType) => [MetricType.DailySteps, MetricType.SleepTime].includes(metricType);
export var AlertLevel;
(function (AlertLevel) {
    AlertLevel[AlertLevel["Unevaluated"] = 0] = "Unevaluated";
    AlertLevel[AlertLevel["Ok"] = 1] = "Ok";
    AlertLevel[AlertLevel["Warning"] = 2] = "Warning";
    AlertLevel[AlertLevel["Alert"] = 3] = "Alert";
})(AlertLevel || (AlertLevel = {}));
